// Demo data for courses
const DEMO_COURSES = [
    {
        id: 1,
        slug: 'introduction-to-web-development',
        image: 'course-1.svg',
        hours: 40,
        price: 1500,
        createdAt: '2024-01-15',
        translations: [
            {
                name: 'Introduction to Web Development',
                description: `
                    <h2>Introduction to Web Development</h2>
                    <p>Start your journey into web development with this comprehensive introduction course. Perfect for absolute beginners, this course will teach you the fundamental building blocks of web development: HTML, CSS, and JavaScript. By the end of this course, you'll be able to create beautiful, interactive websites from scratch.</p>
                    
                    <h3>Course Topics:</h3>
                    <ul>
                        <li><strong>HTML5 Fundamentals:</strong> Learn semantic HTML, forms, tables, multimedia elements, and best practices for creating well-structured web pages.</li>
                        <li><strong>CSS3 Styling:</strong> Master CSS selectors, box model, flexbox, grid layout, responsive design, animations, and transitions to create visually appealing websites.</li>
                        <li><strong>JavaScript Basics:</strong> Understand variables, data types, functions, control structures, DOM manipulation, and event handling to add interactivity to your websites.</li>
                        <li><strong>Responsive Design:</strong> Learn mobile-first design principles and create websites that look great on all devices using media queries and flexible layouts.</li>
                        <li><strong>Project-Based Learning:</strong> Build multiple projects including a personal portfolio website, a landing page, and an interactive web application.</li>
                    </ul>
                    
                    <h3>What You'll Build:</h3>
                    <p>Create a complete portfolio website showcasing your projects, a responsive landing page for a business, and an interactive web application that demonstrates your new skills.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>No prior programming experience required. This course is designed for complete beginners.</p>
                `
            }
        ],
        teachers: [
            {
                id: 1,
                image: 'teacher-1.svg',
                translations: [{ name: 'John Smith' }]
            }
        ],
        programs: [
            {
                id: 1,
                slug: 'web-development',
                image: 'program-1.svg',
                translations: [
                    {
                        name: 'Web Development Program',
                        description: `
                            <h2>Complete Web Development Program</h2>
                            <p>Our comprehensive Web Development Program is designed to transform you from a beginner to a professional full-stack developer. This intensive program covers all aspects of modern web development, from creating beautiful user interfaces to building robust server-side applications. With over 400 hours of hands-on training, you'll master the technologies and skills needed to build production-ready web applications.</p>
                            
                            <h3>What You'll Learn:</h3>
                            <ul>
                                <li><strong>Frontend Development:</strong> Master HTML5, CSS3, JavaScript (ES6+), and modern frameworks like React. Learn to create responsive, interactive user interfaces that work seamlessly across all devices.</li>
                                <li><strong>Backend Development:</strong> Build powerful server-side applications using Node.js and Express. Learn RESTful API design, authentication, and database integration.</li>
                                <li><strong>Full-Stack Integration:</strong> Connect frontend and backend systems, implement real-time features, and deploy applications to production environments.</li>
                                <li><strong>Best Practices:</strong> Follow industry standards for code organization, version control with Git, testing, and performance optimization.</li>
                                <li><strong>DevOps & Deployment:</strong> Deploy applications using cloud platforms, configure CI/CD pipelines, and manage production environments.</li>
                            </ul>
                            
                            <h3>Career Opportunities:</h3>
                            <p>Upon completion, you'll be prepared for roles such as Frontend Developer, Backend Developer, Full-Stack Developer, or Web Application Developer in top tech companies worldwide.</p>
                            
                            <h3>Program Features:</h3>
                            <ul>
                                <li>Hands-on projects and real-world case studies</li>
                                <li>Expert instructors with industry experience</li>
                                <li>Career support and job placement assistance</li>
                                <li>Lifetime access to course materials and updates</li>
                                <li>Portfolio development and code reviews</li>
                            </ul>
                        `
                    },
                    {
                        name: 'برنامج تطوير الويب الكامل',
                        description: `
                            <h2>برنامج تطوير الويب الكامل</h2>
                            <p>تم تصميم برنامج تطوير الويب الشامل لدينا لتحويلك من مبتدئ إلى مطور كامل المكدس محترف. يغطي هذا البرنامج المكثف جميع جوانب تطوير الويب الحديث، من إنشاء واجهات مستخدم جميلة إلى بناء تطبيقات قوية من جانب الخادم. مع أكثر من 400 ساعة من التدريب العملي، سوف تتقن التقنيات والمهارات اللازمة لبناء تطبيقات ويب جاهزة للإنتاج.</p>
                            
                            <h3>ما سوف تتعلمه:</h3>
                            <ul>
                                <li><strong>تطوير الواجهة الأمامية:</strong> إتقان HTML5 و CSS3 و JavaScript (ES6+) وأطر العمل الحديثة مثل React. تعلم إنشاء واجهات مستخدم تفاعلية ومتجاوبة تعمل بسلاسة عبر جميع الأجهزة.</li>
                                <li><strong>تطوير الواجهة الخلفية:</strong> بناء تطبيقات قوية من جانب الخادم باستخدام Node.js و Express. تعلم تصميم واجهات برمجة تطبيقات RESTful والمصادقة وتكامل قواعد البيانات.</li>
                                <li><strong>تكامل المكدس الكامل:</strong> ربط أنظمة الواجهة الأمامية والخلفية، تنفيذ ميزات الوقت الفعلي، ونشر التطبيقات في بيئات الإنتاج.</li>
                                <li><strong>أفضل الممارسات:</strong> اتبع معايير الصناعة لتنظيم الكود والتحكم في الإصدار باستخدام Git والاختبار وتحسين الأداء.</li>
                                <li><strong>DevOps والنشر:</strong> نشر التطبيقات باستخدام منصات السحابة، تكوين خطوط أنابيب CI/CD، وإدارة بيئات الإنتاج.</li>
                            </ul>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>عند الانتهاء، ستكون مستعدًا لأدوار مثل مطور الواجهة الأمامية، مطور الواجهة الخلفية، مطور المكدس الكامل، أو مطور تطبيقات الويب في أفضل شركات التكنولوجيا في جميع أنحاء العالم.</p>
                            
                            <h3>مميزات البرنامج:</h3>
                            <ul>
                                <li>مشاريع عملية ودراسات حالة من العالم الحقيقي</li>
                                <li>مدربون خبراء مع خبرة في الصناعة</li>
                                <li>دعم الوظائف ومساعدة في التوظيف</li>
                                <li>وصول مدى الحياة إلى المواد التعليمية والتحديثات</li>
                                <li>تطوير المحفظة ومراجعات الكود</li>
                            </ul>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 2,
        slug: 'advanced-react-patterns',
        image: 'course-2.svg',
        hours: 30,
        price: 2000,
        createdAt: '2024-01-20',
        translations: [
            {
                name: 'Advanced React Patterns',
                description: `
                    <h2>Advanced React Patterns & Performance</h2>
                    <p>Take your React skills to the next level with this advanced course focused on modern React patterns, performance optimization, and best practices. Learn how to build scalable, maintainable React applications using advanced techniques and patterns used by top-tier companies.</p>
                    
                    <h3>Advanced Concepts Covered:</h3>
                    <ul>
                        <li><strong>Advanced Hooks:</strong> Master custom hooks, useMemo, useCallback, useReducer, and useContext for state management and performance optimization.</li>
                        <li><strong>Context API & State Management:</strong> Implement global state management using Context API, understand when to use Redux vs Context, and manage complex application state.</li>
                        <li><strong>Performance Optimization:</strong> Learn code splitting, lazy loading, memoization, React.memo, virtualization, and bundle size optimization techniques.</li>
                        <li><strong>Advanced Patterns:</strong> Master render props, higher-order components (HOCs), compound components, and controlled vs uncontrolled components.</li>
                        <li><strong>Testing:</strong> Write comprehensive tests using Jest and React Testing Library. Test hooks, context, and complex components.</li>
                        <li><strong>TypeScript with React:</strong> Add type safety to your React applications and catch errors before they reach production.</li>
                    </ul>
                    
                    <h3>Real-World Applications:</h3>
                    <p>Build a production-ready React application implementing all advanced patterns, including performance optimizations, error boundaries, and accessibility best practices.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>Strong understanding of JavaScript ES6+ and basic React concepts (components, props, state).</p>
                `
            }
        ],
        teachers: [
            {
                id: 2,
                image: 'teacher-2.svg',
                translations: [{ name: 'Sarah Johnson' }]
            }
        ],
        programs: [
            {
                id: 1,
                slug: 'web-development',
                image: 'program-1.svg',
                translations: [
                    {
                        name: 'Web Development Program',
                        description: `
                            <h2>Complete Web Development Program</h2>
                            <p>Our comprehensive Web Development Program is designed to transform you from a beginner to a professional full-stack developer. This intensive program covers all aspects of modern web development, from creating beautiful user interfaces to building robust server-side applications. With over 400 hours of hands-on training, you'll master the technologies and skills needed to build production-ready web applications.</p>
                            
                            <h3>What You'll Learn:</h3>
                            <ul>
                                <li><strong>Frontend Development:</strong> Master HTML5, CSS3, JavaScript (ES6+), and modern frameworks like React. Learn to create responsive, interactive user interfaces that work seamlessly across all devices.</li>
                                <li><strong>Backend Development:</strong> Build powerful server-side applications using Node.js and Express. Learn RESTful API design, authentication, and database integration.</li>
                                <li><strong>Full-Stack Integration:</strong> Connect frontend and backend systems, implement real-time features, and deploy applications to production environments.</li>
                                <li><strong>Best Practices:</strong> Follow industry standards for code organization, version control with Git, testing, and performance optimization.</li>
                                <li><strong>DevOps & Deployment:</strong> Deploy applications using cloud platforms, configure CI/CD pipelines, and manage production environments.</li>
                            </ul>
                            
                            <h3>Career Opportunities:</h3>
                            <p>Upon completion, you'll be prepared for roles such as Frontend Developer, Backend Developer, Full-Stack Developer, or Web Application Developer in top tech companies worldwide.</p>
                            
                            <h3>Program Features:</h3>
                            <ul>
                                <li>Hands-on projects and real-world case studies</li>
                                <li>Expert instructors with industry experience</li>
                                <li>Career support and job placement assistance</li>
                                <li>Lifetime access to course materials and updates</li>
                                <li>Portfolio development and code reviews</li>
                            </ul>
                        `
                    },
                    {
                        name: 'برنامج تطوير الويب الكامل',
                        description: `
                            <h2>برنامج تطوير الويب الكامل</h2>
                            <p>تم تصميم برنامج تطوير الويب الشامل لدينا لتحويلك من مبتدئ إلى مطور كامل المكدس محترف. يغطي هذا البرنامج المكثف جميع جوانب تطوير الويب الحديث، من إنشاء واجهات مستخدم جميلة إلى بناء تطبيقات قوية من جانب الخادم. مع أكثر من 400 ساعة من التدريب العملي، سوف تتقن التقنيات والمهارات اللازمة لبناء تطبيقات ويب جاهزة للإنتاج.</p>
                            
                            <h3>ما سوف تتعلمه:</h3>
                            <ul>
                                <li><strong>تطوير الواجهة الأمامية:</strong> إتقان HTML5 و CSS3 و JavaScript (ES6+) وأطر العمل الحديثة مثل React. تعلم إنشاء واجهات مستخدم تفاعلية ومتجاوبة تعمل بسلاسة عبر جميع الأجهزة.</li>
                                <li><strong>تطوير الواجهة الخلفية:</strong> بناء تطبيقات قوية من جانب الخادم باستخدام Node.js و Express. تعلم تصميم واجهات برمجة تطبيقات RESTful والمصادقة وتكامل قواعد البيانات.</li>
                                <li><strong>تكامل المكدس الكامل:</strong> ربط أنظمة الواجهة الأمامية والخلفية، تنفيذ ميزات الوقت الفعلي، ونشر التطبيقات في بيئات الإنتاج.</li>
                                <li><strong>أفضل الممارسات:</strong> اتبع معايير الصناعة لتنظيم الكود والتحكم في الإصدار باستخدام Git والاختبار وتحسين الأداء.</li>
                                <li><strong>DevOps والنشر:</strong> نشر التطبيقات باستخدام منصات السحابة، تكوين خطوط أنابيب CI/CD، وإدارة بيئات الإنتاج.</li>
                            </ul>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>عند الانتهاء، ستكون مستعدًا لأدوار مثل مطور الواجهة الأمامية، مطور الواجهة الخلفية، مطور المكدس الكامل، أو مطور تطبيقات الويب في أفضل شركات التكنولوجيا في جميع أنحاء العالم.</p>
                            
                            <h3>مميزات البرنامج:</h3>
                            <ul>
                                <li>مشاريع عملية ودراسات حالة من العالم الحقيقي</li>
                                <li>مدربون خبراء مع خبرة في الصناعة</li>
                                <li>دعم الوظائف ومساعدة في التوظيف</li>
                                <li>وصول مدى الحياة إلى المواد التعليمية والتحديثات</li>
                                <li>تطوير المحفظة ومراجعات الكود</li>
                            </ul>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 3,
        slug: 'nodejs-backend-development',
        image: 'course-3.svg',
        hours: 50,
        price: 2500,
        createdAt: '2024-02-01',
        translations: [
            {
                name: 'Node.js Backend Development',
                description: `
                    <h2>Node.js Backend Development</h2>
                    <p>Master server-side JavaScript development with Node.js. Learn to build robust, scalable backend applications and RESTful APIs using Express.js, connect to databases, implement authentication, and deploy your applications to production.</p>
                    
                    <h3>Core Topics:</h3>
                    <ul>
                        <li><strong>Node.js Fundamentals:</strong> Understand the event loop, asynchronous programming, streams, buffers, and Node.js core modules.</li>
                        <li><strong>Express.js Framework:</strong> Build RESTful APIs, handle routing, middleware, error handling, and request validation.</li>
                        <li><strong>Database Integration:</strong> Connect to MongoDB using Mongoose, implement CRUD operations, work with relationships, and optimize database queries.</li>
                        <li><strong>Authentication & Security:</strong> Implement JWT authentication, password hashing with bcrypt, API security best practices, and protect routes.</li>
                        <li><strong>File Upload & Processing:</strong> Handle file uploads, image processing, and file management using Multer and cloud storage services.</li>
                        <li><strong>API Design:</strong> Design RESTful APIs following best practices, implement pagination, filtering, sorting, and API versioning.</li>
                        <li><strong>Testing & Deployment:</strong> Write unit and integration tests, set up CI/CD pipelines, and deploy applications to cloud platforms like Heroku, AWS, or DigitalOcean.</li>
                    </ul>
                    
                    <h3>Projects:</h3>
                    <p>Build a complete e-commerce backend API with authentication, product management, shopping cart, and order processing functionality.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>Solid JavaScript knowledge, understanding of asynchronous programming, and basic knowledge of HTTP and APIs.</p>
                `
            }
        ],
        teachers: [
            {
                id: 3,
                image: 'teacher-3.svg',
                translations: [{ name: 'Michael Brown' }]
            }
        ],
        programs: [
            {
                id: 1,
                slug: 'web-development',
                image: 'program-1.svg',
                translations: [
                    {
                        name: 'Web Development Program',
                        description: `
                            <h2>Complete Web Development Program</h2>
                            <p>Our comprehensive Web Development Program is designed to transform you from a beginner to a professional full-stack developer. This intensive program covers all aspects of modern web development, from creating beautiful user interfaces to building robust server-side applications. With over 400 hours of hands-on training, you'll master the technologies and skills needed to build production-ready web applications.</p>
                            
                            <h3>What You'll Learn:</h3>
                            <ul>
                                <li><strong>Frontend Development:</strong> Master HTML5, CSS3, JavaScript (ES6+), and modern frameworks like React. Learn to create responsive, interactive user interfaces that work seamlessly across all devices.</li>
                                <li><strong>Backend Development:</strong> Build powerful server-side applications using Node.js and Express. Learn RESTful API design, authentication, and database integration.</li>
                                <li><strong>Full-Stack Integration:</strong> Connect frontend and backend systems, implement real-time features, and deploy applications to production environments.</li>
                                <li><strong>Best Practices:</strong> Follow industry standards for code organization, version control with Git, testing, and performance optimization.</li>
                                <li><strong>DevOps & Deployment:</strong> Deploy applications using cloud platforms, configure CI/CD pipelines, and manage production environments.</li>
                            </ul>
                            
                            <h3>Career Opportunities:</h3>
                            <p>Upon completion, you'll be prepared for roles such as Frontend Developer, Backend Developer, Full-Stack Developer, or Web Application Developer in top tech companies worldwide.</p>
                            
                            <h3>Program Features:</h3>
                            <ul>
                                <li>Hands-on projects and real-world case studies</li>
                                <li>Expert instructors with industry experience</li>
                                <li>Career support and job placement assistance</li>
                                <li>Lifetime access to course materials and updates</li>
                                <li>Portfolio development and code reviews</li>
                            </ul>
                        `
                    },
                    {
                        name: 'برنامج تطوير الويب الكامل',
                        description: `
                            <h2>برنامج تطوير الويب الكامل</h2>
                            <p>تم تصميم برنامج تطوير الويب الشامل لدينا لتحويلك من مبتدئ إلى مطور كامل المكدس محترف. يغطي هذا البرنامج المكثف جميع جوانب تطوير الويب الحديث، من إنشاء واجهات مستخدم جميلة إلى بناء تطبيقات قوية من جانب الخادم. مع أكثر من 400 ساعة من التدريب العملي، سوف تتقن التقنيات والمهارات اللازمة لبناء تطبيقات ويب جاهزة للإنتاج.</p>
                            
                            <h3>ما سوف تتعلمه:</h3>
                            <ul>
                                <li><strong>تطوير الواجهة الأمامية:</strong> إتقان HTML5 و CSS3 و JavaScript (ES6+) وأطر العمل الحديثة مثل React. تعلم إنشاء واجهات مستخدم تفاعلية ومتجاوبة تعمل بسلاسة عبر جميع الأجهزة.</li>
                                <li><strong>تطوير الواجهة الخلفية:</strong> بناء تطبيقات قوية من جانب الخادم باستخدام Node.js و Express. تعلم تصميم واجهات برمجة تطبيقات RESTful والمصادقة وتكامل قواعد البيانات.</li>
                                <li><strong>تكامل المكدس الكامل:</strong> ربط أنظمة الواجهة الأمامية والخلفية، تنفيذ ميزات الوقت الفعلي، ونشر التطبيقات في بيئات الإنتاج.</li>
                                <li><strong>أفضل الممارسات:</strong> اتبع معايير الصناعة لتنظيم الكود والتحكم في الإصدار باستخدام Git والاختبار وتحسين الأداء.</li>
                                <li><strong>DevOps والنشر:</strong> نشر التطبيقات باستخدام منصات السحابة، تكوين خطوط أنابيب CI/CD، وإدارة بيئات الإنتاج.</li>
                            </ul>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>عند الانتهاء، ستكون مستعدًا لأدوار مثل مطور الواجهة الأمامية، مطور الواجهة الخلفية، مطور المكدس الكامل، أو مطور تطبيقات الويب في أفضل شركات التكنولوجيا في جميع أنحاء العالم.</p>
                            
                            <h3>مميزات البرنامج:</h3>
                            <ul>
                                <li>مشاريع عملية ودراسات حالة من العالم الحقيقي</li>
                                <li>مدربون خبراء مع خبرة في الصناعة</li>
                                <li>دعم الوظائف ومساعدة في التوظيف</li>
                                <li>وصول مدى الحياة إلى المواد التعليمية والتحديثات</li>
                                <li>تطوير المحفظة ومراجعات الكود</li>
                            </ul>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 4,
        slug: 'python-data-science',
        image: 'course-4.svg',
        hours: 60,
        price: 3000,
        createdAt: '2024-02-10',
        translations: [
            {
                name: 'Python for Data Science',
                description: `
                    <h2>Python for Data Science</h2>
                    <p>Unlock the power of Python for data analysis and machine learning. This comprehensive course teaches you how to use Python's most powerful data science libraries including NumPy, Pandas, Matplotlib, Seaborn, and scikit-learn to analyze data, build predictive models, and derive meaningful insights.</p>
                    
                    <h3>Course Curriculum:</h3>
                    <ul>
                        <li><strong>Python Basics for Data Science:</strong> Review Python fundamentals with focus on data structures, list comprehensions, and object-oriented programming for data analysis.</li>
                        <li><strong>NumPy:</strong> Master array operations, vectorization, broadcasting, and numerical computing for efficient data manipulation.</li>
                        <li><strong>Pandas:</strong> Learn data manipulation with DataFrames, data cleaning, merging, grouping, pivoting, and handling time series data.</li>
                        <li><strong>Data Visualization:</strong> Create stunning visualizations using Matplotlib and Seaborn. Build interactive dashboards and communicate insights effectively.</li>
                        <li><strong>Data Cleaning & Preprocessing:</strong> Handle missing data, outliers, data normalization, feature engineering, and prepare data for machine learning.</li>
                        <li><strong>Machine Learning with scikit-learn:</strong> Implement regression, classification, and clustering algorithms. Learn model evaluation, cross-validation, and hyperparameter tuning.</li>
                        <li><strong>Real-World Projects:</strong> Analyze datasets from various domains including finance, e-commerce, healthcare, and social media.</li>
                    </ul>
                    
                    <h3>Hands-On Practice:</h3>
                    <p>Work on multiple projects including customer segmentation analysis, sales forecasting, sentiment analysis, and predictive modeling for business decisions.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>Basic Python programming knowledge is recommended. Familiarity with basic statistics is helpful but not required.</p>
                `
            }
        ],
        teachers: [
            {
                id: 4,
                image: 'teacher-4.svg',
                translations: [{ name: 'Emily Davis' }]
            }
        ],
        programs: [
            {
                id: 2,
                slug: 'data-science',
                image: 'program-2.svg',
                translations: [
                    {
                        name: 'Data Science Program',
                        description: `
                            <h2>Comprehensive Data Science Program</h2>
                            <p>Embark on a journey into the world of data science with our comprehensive program that covers everything from statistical analysis to advanced machine learning and artificial intelligence. Whether you're a complete beginner or looking to advance your skills, this program provides the foundation and advanced techniques needed to excel in the rapidly growing field of data science.</p>
                            
                            <h3>Curriculum Overview:</h3>
                            <ul>
                                <li><strong>Statistics & Probability:</strong> Master fundamental statistical concepts, hypothesis testing, regression analysis, and probability distributions essential for data analysis.</li>
                                <li><strong>Python Programming:</strong> Learn Python from scratch with focus on data manipulation using NumPy, Pandas, and data visualization with Matplotlib and Seaborn.</li>
                                <li><strong>Data Wrangling:</strong> Clean, transform, and prepare messy real-world data for analysis. Learn to handle missing data, outliers, and data quality issues.</li>
                                <li><strong>Machine Learning:</strong> Implement supervised and unsupervised learning algorithms using scikit-learn. Build predictive models, classification systems, and clustering solutions.</li>
                                <li><strong>Deep Learning:</strong> Introduction to neural networks, TensorFlow, and Keras. Build deep learning models for image recognition, natural language processing, and more.</li>
                                <li><strong>Big Data Technologies:</strong> Work with large datasets using tools like SQL, Apache Spark, and cloud computing platforms.</li>
                            </ul>
                            
                            <h3>Real-World Applications:</h3>
                            <p>Apply your skills to real-world problems including predictive analytics, customer segmentation, fraud detection, recommendation systems, and natural language processing.</p>
                            
                            <h3>Career Path:</h3>
                            <p>Graduates of this program are prepared for roles such as Data Analyst, Data Scientist, Machine Learning Engineer, Business Intelligence Analyst, and AI Specialist.</p>
                        `
                    },
                    {
                        name: 'برنامج علوم البيانات الشامل',
                        description: `
                            <h2>برنامج علوم البيانات الشامل</h2>
                            <p>انطلق في رحلة إلى عالم علوم البيانات مع برنامجنا الشامل الذي يغطي كل شيء من التحليل الإحصائي إلى التعلم الآلي المتقدم والذكاء الاصطناعي. سواء كنت مبتدئًا تمامًا أو تتطلع إلى تطوير مهاراتك، يوفر هذا البرنامج الأساس والتقنيات المتقدمة اللازمة للتفوق في مجال علوم البيانات سريع النمو.</p>
                            
                            <h3>نظرة عامة على المنهج:</h3>
                            <ul>
                                <li><strong>الإحصاء والاحتمالات:</strong> إتقان المفاهيم الإحصائية الأساسية، اختبار الفرضيات، تحليل الانحدار، وتوزيعات الاحتمالات الضرورية لتحليل البيانات.</li>
                                <li><strong>برمجة Python:</strong> تعلم Python من الصفر مع التركيز على معالجة البيانات باستخدام NumPy و Pandas وتصور البيانات باستخدام Matplotlib و Seaborn.</li>
                                <li><strong>معالجة البيانات:</strong> تنظيف وتحويل وإعداد البيانات الفعلية الفوضوية للتحليل. تعلم التعامل مع البيانات المفقودة والقيم المتطرفة ومشاكل جودة البيانات.</li>
                                <li><strong>التعلم الآلي:</strong> تنفيذ خوارزميات التعلم الخاضع للإشراف وغير الخاضع للإشراف باستخدام scikit-learn. بناء نماذج تنبؤية وأنظمة تصنيف وحلول التجميع.</li>
                                <li><strong>التعلم العميق:</strong> مقدمة للشبكات العصبية و TensorFlow و Keras. بناء نماذج التعلم العميق للتعرف على الصور ومعالجة اللغة الطبيعية والمزيد.</li>
                                <li><strong>تقنيات البيانات الضخمة:</strong> العمل مع مجموعات البيانات الكبيرة باستخدام أدوات مثل SQL و Apache Spark ومنصات الحوسبة السحابية.</li>
                            </ul>
                            
                            <h3>التطبيقات الواقعية:</h3>
                            <p>طبق مهاراتك على مشاكل واقعية بما في ذلك التحليلات التنبؤية وتقسيم العملاء وكشف الاحتيال وأنظمة التوصية ومعالجة اللغة الطبيعية.</p>
                            
                            <h3>المسار الوظيفي:</h3>
                            <p>خريجو هذا البرنامج مستعدون لأدوار مثل محلل البيانات وعالم البيانات ومهندس التعلم الآلي ومحلل ذكاء الأعمال وأخصائي الذكاء الاصطناعي.</p>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 5,
        slug: 'ui-ux-design-fundamentals',
        image: 'course-5.svg',
        hours: 35,
        price: 1800,
        createdAt: '2024-02-15',
        translations: [
            {
                name: 'UI/UX Design Fundamentals',
                description: `
                    <h2>UI/UX Design Fundamentals</h2>
                    <p>Learn the essential principles and practices of user interface and user experience design. This course covers everything from understanding user needs to creating beautiful, functional designs that solve real problems. Perfect for aspiring designers and developers who want to create better user experiences.</p>
                    
                    <h3>What You'll Learn:</h3>
                    <ul>
                        <li><strong>UX Research:</strong> Conduct user interviews, create user personas, map user journeys, and perform competitive analysis to understand user needs.</li>
                        <li><strong>Information Architecture:</strong> Organize content logically, create sitemaps, design navigation systems, and structure information for optimal usability.</li>
                        <li><strong>Wireframing & Prototyping:</strong> Create low-fidelity and high-fidelity wireframes, build interactive prototypes, and test design concepts before development.</li>
                        <li><strong>Visual Design Principles:</strong> Master color theory, typography, spacing, visual hierarchy, and composition to create visually appealing interfaces.</li>
                        <li><strong>Design Tools:</strong> Learn to use Figma and Adobe XD for creating designs, building prototypes, and collaborating with teams.</li>
                        <li><strong>Responsive Design:</strong> Design for multiple screen sizes, understand breakpoints, and create designs that adapt to different devices.</li>
                        <li><strong>Usability Testing:</strong> Plan and conduct usability tests, analyze feedback, and iterate on designs based on user insights.</li>
                        <li><strong>Accessibility:</strong> Design inclusive interfaces that are accessible to all users, including those with disabilities.</li>
                    </ul>
                    
                    <h3>Portfolio Projects:</h3>
                    <p>Complete a full UX design project from research to final prototype, including a mobile app redesign and a website design for a real business case.</p>
                    
                    <h3>Career Impact:</h3>
                    <p>Build a portfolio that demonstrates your design thinking process and prepares you for roles as a UI/UX Designer, Product Designer, or UX Researcher.</p>
                `
            }
        ],
        teachers: [
            {
                id: 5,
                image: 'teacher-5.svg',
                translations: [{ name: 'David Wilson' }]
            }
        ],
        programs: [
            {
                id: 3,
                slug: 'design',
                image: 'program-3.svg',
                translations: [
                    {
                        name: 'Design Program',
                        description: `
                            <h2>Professional Design Program</h2>
                            <p>Transform your creative passion into a professional design career with our comprehensive Design Program. This program combines the art of visual design with the science of user experience to create designs that are not only beautiful but also functional, accessible, and user-centered.</p>
                            
                            <h3>Program Components:</h3>
                            <ul>
                                <li><strong>UI Design Fundamentals:</strong> Master the principles of interface design, including color theory, typography, layout, spacing, and visual hierarchy. Learn to create intuitive and visually appealing user interfaces.</li>
                                <li><strong>UX Design & Research:</strong> Conduct user research, create personas and user journeys, design information architecture, and perform usability testing to ensure your designs meet user needs.</li>
                                <li><strong>Design Tools Mastery:</strong> Become proficient in industry-standard tools including Figma, Adobe XD, Sketch, Photoshop, and Illustrator. Learn workflow optimization and collaboration techniques.</li>
                                <li><strong>Responsive Design:</strong> Design for multiple screen sizes and devices. Understand mobile-first design principles and create designs that work across desktop, tablet, and mobile platforms.</li>
                                <li><strong>Prototyping & Interaction:</strong> Create interactive prototypes, design micro-interactions, animations, and transitions that enhance user experience.</li>
                                <li><strong>Design Systems:</strong> Build and maintain design systems, component libraries, and style guides for consistent design implementation.</li>
                            </ul>
                            
                            <h3>Portfolio Development:</h3>
                            <p>Build a professional portfolio showcasing web and mobile app designs, branding projects, and UX case studies that demonstrate your design thinking process.</p>
                            
                            <h3>Career Opportunities:</h3>
                            <p>This program prepares you for careers as a UI Designer, UX Designer, Product Designer, Visual Designer, or Interaction Designer in startups, agencies, and enterprise companies.</p>
                        `
                    },
                    {
                        name: 'برنامج التصميم الاحترافي',
                        description: `
                            <h2>برنامج التصميم الاحترافي</h2>
                            <p>حول شغفك الإبداعي إلى مهنة تصميم احترافية مع برنامج التصميم الشامل لدينا. يجمع هذا البرنامج بين فن التصميم البصري وعلم تجربة المستخدم لإنشاء تصاميم ليست جميلة فحسب، بل أيضًا وظيفية ومتاحة وتركز على المستخدم.</p>
                            
                            <h3>مكونات البرنامج:</h3>
                            <ul>
                                <li><strong>أساسيات تصميم واجهة المستخدم:</strong> إتقان مبادئ تصميم الواجهة، بما في ذلك نظرية الألوان والطباعة والتخطيط والمسافات والتسلسل الهرمي البصري. تعلم إنشاء واجهات مستخدم بديهية وجذابة بصريًا.</li>
                                <li><strong>تصميم تجربة المستخدم والبحث:</strong> إجراء بحث المستخدم، إنشاء الشخصيات ومسارات المستخدم، تصميم هندسة المعلومات، وإجراء اختبارات قابلية الاستخدام لضمان تلبية تصاميمك لاحتياجات المستخدم.</li>
                                <li><strong>إتقان أدوات التصميم:</strong> احتراف الأدوات القياسية في الصناعة بما في ذلك Figma و Adobe XD و Sketch و Photoshop و Illustrator. تعلم تحسين سير العمل وتقنيات التعاون.</li>
                                <li><strong>التصميم المتجاوب:</strong> التصميم لأحجام شاشات وأجهزة متعددة. فهم مبادئ التصميم التي تركز على الجوال وإنشاء تصاميم تعمل عبر منصات سطح المكتب والجهاز اللوحي والجوال.</li>
                                <li><strong>النماذج الأولية والتفاعل:</strong> إنشاء نماذج أولية تفاعلية، تصميم التفاعلات الدقيقة والرسوم المتحركة والانتقالات التي تعزز تجربة المستخدم.</li>
                                <li><strong>أنظمة التصميم:</strong> بناء وصيانة أنظمة التصميم ومكتبات المكونات وأدلة الأنماط لتنفيذ تصميم متسق.</li>
                            </ul>
                            
                            <h3>تطوير المحفظة:</h3>
                            <p>بناء محفظة احترافية تعرض تصاميم تطبيقات الويب والجوال ومشاريع العلامات التجارية ودراسات حالة تجربة المستخدم التي تظهر عملية تفكيرك في التصميم.</p>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>يعدك هذا البرنامج لمهن كمصمم واجهة المستخدم، مصمم تجربة المستخدم، مصمم المنتجات، المصمم البصري، أو مصمم التفاعل في الشركات الناشئة والوكالات والشركات الكبيرة.</p>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 6,
        slug: 'mobile-app-development',
        image: 'course-6.svg',
        hours: 45,
        price: 2200,
        createdAt: '2024-03-01',
        translations: [
            {
                name: 'Mobile App Development',
                description: `
                    <h2>Mobile App Development with React Native</h2>
                    <p>Learn to build professional mobile applications for both iOS and Android using React Native. Master cross-platform development, native modules, state management, and app deployment. Create real mobile apps that users love.</p>
                    
                    <h3>Course Content:</h3>
                    <ul>
                        <li><strong>React Native Basics:</strong> Set up development environment, understand React Native architecture, components, styling with StyleSheet, and Flexbox layouts.</li>
                        <li><strong>Navigation:</strong> Implement navigation using React Navigation, create stack, tab, and drawer navigators for complex app structures.</li>
                        <li><strong>State Management:</strong> Manage application state using React Hooks, Context API, and Redux for complex applications.</li>
                        <li><strong>Native APIs:</strong> Access device features including camera, geolocation, push notifications, and device storage using native modules.</li>
                        <li><strong>HTTP & APIs:</strong> Integrate with RESTful APIs, handle async operations, implement error handling, and manage loading states.</li>
                        <li><strong>Forms & User Input:</strong> Create forms, handle user input validation, implement authentication flows, and manage user sessions.</li>
                        <li><strong>Performance Optimization:</strong> Optimize app performance, reduce bundle size, implement code splitting, and improve rendering performance.</li>
                        <li><strong>Deployment:</strong> Build apps for iOS and Android, configure app store listings, and deploy to Apple App Store and Google Play Store.</li>
                    </ul>
                    
                    <h3>Projects:</h3>
                    <p>Build a complete social media app with authentication, feeds, profiles, and real-time updates. Also create a weather app and a task management application.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>Strong JavaScript and React knowledge. Basic understanding of mobile app concepts is helpful but not required.</p>
                `
            }
        ],
        teachers: [
            {
                id: 1,
                image: 'teacher-1.svg',
                translations: [{ name: 'John Smith' }]
            }
        ],
        programs: [
            {
                id: 1,
                slug: 'web-development',
                image: 'program-1.svg',
                translations: [
                    {
                        name: 'Web Development Program',
                        description: `
                            <h2>Complete Web Development Program</h2>
                            <p>Our comprehensive Web Development Program is designed to transform you from a beginner to a professional full-stack developer. This intensive program covers all aspects of modern web development, from creating beautiful user interfaces to building robust server-side applications. With over 400 hours of hands-on training, you'll master the technologies and skills needed to build production-ready web applications.</p>
                            
                            <h3>What You'll Learn:</h3>
                            <ul>
                                <li><strong>Frontend Development:</strong> Master HTML5, CSS3, JavaScript (ES6+), and modern frameworks like React. Learn to create responsive, interactive user interfaces that work seamlessly across all devices.</li>
                                <li><strong>Backend Development:</strong> Build powerful server-side applications using Node.js and Express. Learn RESTful API design, authentication, and database integration.</li>
                                <li><strong>Full-Stack Integration:</strong> Connect frontend and backend systems, implement real-time features, and deploy applications to production environments.</li>
                                <li><strong>Best Practices:</strong> Follow industry standards for code organization, version control with Git, testing, and performance optimization.</li>
                                <li><strong>DevOps & Deployment:</strong> Deploy applications using cloud platforms, configure CI/CD pipelines, and manage production environments.</li>
                            </ul>
                            
                            <h3>Career Opportunities:</h3>
                            <p>Upon completion, you'll be prepared for roles such as Frontend Developer, Backend Developer, Full-Stack Developer, or Web Application Developer in top tech companies worldwide.</p>
                            
                            <h3>Program Features:</h3>
                            <ul>
                                <li>Hands-on projects and real-world case studies</li>
                                <li>Expert instructors with industry experience</li>
                                <li>Career support and job placement assistance</li>
                                <li>Lifetime access to course materials and updates</li>
                                <li>Portfolio development and code reviews</li>
                            </ul>
                        `
                    },
                    {
                        name: 'برنامج تطوير الويب الكامل',
                        description: `
                            <h2>برنامج تطوير الويب الكامل</h2>
                            <p>تم تصميم برنامج تطوير الويب الشامل لدينا لتحويلك من مبتدئ إلى مطور كامل المكدس محترف. يغطي هذا البرنامج المكثف جميع جوانب تطوير الويب الحديث، من إنشاء واجهات مستخدم جميلة إلى بناء تطبيقات قوية من جانب الخادم. مع أكثر من 400 ساعة من التدريب العملي، سوف تتقن التقنيات والمهارات اللازمة لبناء تطبيقات ويب جاهزة للإنتاج.</p>
                            
                            <h3>ما سوف تتعلمه:</h3>
                            <ul>
                                <li><strong>تطوير الواجهة الأمامية:</strong> إتقان HTML5 و CSS3 و JavaScript (ES6+) وأطر العمل الحديثة مثل React. تعلم إنشاء واجهات مستخدم تفاعلية ومتجاوبة تعمل بسلاسة عبر جميع الأجهزة.</li>
                                <li><strong>تطوير الواجهة الخلفية:</strong> بناء تطبيقات قوية من جانب الخادم باستخدام Node.js و Express. تعلم تصميم واجهات برمجة تطبيقات RESTful والمصادقة وتكامل قواعد البيانات.</li>
                                <li><strong>تكامل المكدس الكامل:</strong> ربط أنظمة الواجهة الأمامية والخلفية، تنفيذ ميزات الوقت الفعلي، ونشر التطبيقات في بيئات الإنتاج.</li>
                                <li><strong>أفضل الممارسات:</strong> اتبع معايير الصناعة لتنظيم الكود والتحكم في الإصدار باستخدام Git والاختبار وتحسين الأداء.</li>
                                <li><strong>DevOps والنشر:</strong> نشر التطبيقات باستخدام منصات السحابة، تكوين خطوط أنابيب CI/CD، وإدارة بيئات الإنتاج.</li>
                            </ul>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>عند الانتهاء، ستكون مستعدًا لأدوار مثل مطور الواجهة الأمامية، مطور الواجهة الخلفية، مطور المكدس الكامل، أو مطور تطبيقات الويب في أفضل شركات التكنولوجيا في جميع أنحاء العالم.</p>
                            
                            <h3>مميزات البرنامج:</h3>
                            <ul>
                                <li>مشاريع عملية ودراسات حالة من العالم الحقيقي</li>
                                <li>مدربون خبراء مع خبرة في الصناعة</li>
                                <li>دعم الوظائف ومساعدة في التوظيف</li>
                                <li>وصول مدى الحياة إلى المواد التعليمية والتحديثات</li>
                                <li>تطوير المحفظة ومراجعات الكود</li>
                            </ul>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 7,
        slug: 'database-design',
        image: 'course-7.svg',
        hours: 25,
        price: 1200,
        createdAt: '2024-03-10',
        translations: [
            {
                name: 'Database Design and SQL',
                description: `
                    <h2>Database Design and SQL Mastery</h2>
                    <p>Master the fundamentals of database design and SQL programming. Learn to design efficient database schemas, write complex SQL queries, and manage databases effectively. Essential skills for any developer working with data.</p>
                    
                    <h3>Learning Objectives:</h3>
                    <ul>
                        <li><strong>Database Design:</strong> Learn entity-relationship modeling, normalization (1NF, 2NF, 3NF), database schemas, relationships, and data integrity constraints.</li>
                        <li><strong>SQL Fundamentals:</strong> Master SELECT statements, WHERE clauses, JOINs (INNER, LEFT, RIGHT, FULL), aggregations, and subqueries.</li>
                        <li><strong>Advanced SQL:</strong> Learn stored procedures, functions, triggers, views, indexes, transactions, and performance optimization techniques.</li>
                        <li><strong>Data Manipulation:</strong> Insert, update, delete data efficiently. Learn about constraints, cascading operations, and data validation.</li>
                        <li><strong>Database Management:</strong> Understand database administration basics including user management, permissions, backups, and recovery.</li>
                        <li><strong>MySQL & PostgreSQL:</strong> Work with both popular database systems, understand their differences, and learn system-specific features.</li>
                        <li><strong>Real-World Scenarios:</h3></strong> Design and implement databases for e-commerce, content management, and analytics applications.</li>
                    </ul>
                    
                    <h3>Practical Projects:</h3>
                    <p>Design a complete database for an online bookstore, create a database for a blog platform, and optimize existing databases for better performance.</p>
                    
                    <h3>Career Benefits:</h3>
                    <p>SQL is one of the most in-demand skills in tech. This course prepares you for roles in backend development, data analysis, database administration, and business intelligence.</p>
                `
            }
        ],
        teachers: [
            {
                id: 3,
                image: 'teacher-3.svg',
                translations: [{ name: 'Michael Brown' }]
            }
        ],
        programs: [
            {
                id: 4,
                slug: 'database',
                image: 'program-4.svg',
                translations: [
                    {
                        name: 'Database Program',
                        description: `
                            <h2>Database Design & Management Program</h2>
                            <p>Master the art and science of database design, development, and administration with our comprehensive Database Program. Learn to design efficient database schemas, write optimized queries, and manage data across different database systems. This program is essential for anyone working with data-intensive applications.</p>
                            
                            <h3>Key Learning Areas:</h3>
                            <ul>
                                <li><strong>Database Design Principles:</strong> Learn entity-relationship modeling, normalization techniques, database schemas, and data integrity constraints. Design scalable and maintainable database structures.</li>
                                <li><strong>SQL Mastery:</strong> Master Structured Query Language (SQL) for data manipulation and querying. Learn complex joins, subqueries, stored procedures, triggers, and transactions.</li>
                                <li><strong>Relational Databases:</strong> Work extensively with MySQL and PostgreSQL. Understand ACID properties, indexing strategies, query optimization, and performance tuning.</li>
                                <li><strong>NoSQL Databases:</strong> Explore MongoDB, Redis, and other NoSQL solutions. Understand when to use document, key-value, or graph databases.</li>
                                <li><strong>Database Administration:</strong> Learn backup and recovery, security best practices, user management, monitoring, and troubleshooting database issues.</li>
                                <li><strong>Advanced Topics:</strong> Cover database replication, sharding, data warehousing, ETL processes, and working with big data technologies.</li>
                            </ul>
                            
                            <h3>Hands-On Projects:</h3>
                            <p>Design and implement databases for e-commerce platforms, content management systems, and analytics applications. Optimize existing databases for performance and scale.</p>
                            
                            <h3>Career Paths:</h3>
                            <p>Graduates are prepared for roles such as Database Administrator, Database Developer, Data Engineer, Backend Developer with database expertise, and Business Intelligence Developer.</p>
                        `
                    },
                    {
                        name: 'برنامج تصميم وإدارة قواعد البيانات',
                        description: `
                            <h2>برنامج تصميم وإدارة قواعد البيانات</h2>
                            <p>أتقن فن وعلم تصميم قواعد البيانات وتطويرها وإدارتها مع برنامج قواعد البيانات الشامل لدينا. تعلم تصميم مخططات قواعد بيانات فعالة، كتابة استعلامات محسنة، وإدارة البيانات عبر أنظمة قواعد البيانات المختلفة. هذا البرنامج ضروري لأي شخص يعمل مع التطبيقات المكثفة بالبيانات.</p>
                            
                            <h3>مجالات التعلم الرئيسية:</h3>
                            <ul>
                                <li><strong>مبادئ تصميم قواعد البيانات:</strong> تعلم نمذجة الكيانات والعلاقات، تقنيات التسوية، مخططات قواعد البيانات، وقيود تكامل البيانات. تصميم هياكل قواعد بيانات قابلة للتوسع والصيانة.</li>
                                <li><strong>إتقان SQL:</strong> إتقان لغة الاستعلامات المهيكلة (SQL) لمعالجة البيانات والاستعلام. تعلم الـ JOINs المعقدة والاستعلامات الفرعية والإجراءات المخزنة والمشغلات والمعاملات.</li>
                                <li><strong>قواعد البيانات العلائقية:</strong> العمل على نطاق واسع مع MySQL و PostgreSQL. فهم خصائص ACID واستراتيجيات الفهرسة وتحسين الاستعلامات وضبط الأداء.</li>
                                <li><strong>قواعد البيانات NoSQL:</strong> استكشف MongoDB و Redis وحلول NoSQL أخرى. فهم متى تستخدم قواعد البيانات المستندة أو المفتاح-القيمة أو الرسم البياني.</li>
                                <li><strong>إدارة قواعد البيانات:</strong> تعلم النسخ الاحتياطي والاستعادة، أفضل ممارسات الأمان، إدارة المستخدمين، المراقبة، وحل مشاكل قواعد البيانات.</li>
                                <li><strong>مواضيع متقدمة:</strong> تغطية تكرار قواعد البيانات، التقسيم، مستودعات البيانات، عمليات ETL، والعمل مع تقنيات البيانات الضخمة.</li>
                            </ul>
                            
                            <h3>المشاريع العملية:</h3>
                            <p>تصميم وتنفيذ قواعد بيانات لمنصات التجارة الإلكترونية وأنظمة إدارة المحتوى وتطبيقات التحليلات. تحسين قواعد البيانات الموجودة للأداء والتوسع.</p>
                            
                            <h3>المسارات الوظيفية:</h3>
                            <p>الخريجون مستعدون لأدوار مثل مدير قواعد البيانات، مطور قواعد البيانات، مهندس البيانات، مطور الواجهة الخلفية مع خبرة في قواعد البيانات، ومطور ذكاء الأعمال.</p>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 8,
        slug: 'javascript-fundamentals',
        image: 'course-8.svg',
        hours: 30,
        price: 1400,
        createdAt: '2024-03-15',
        translations: [
            {
                name: 'JavaScript Fundamentals',
                description: `
                    <h2>JavaScript Fundamentals to Advanced</h2>
                    <p>Master JavaScript, the most popular programming language in the world. This comprehensive course covers everything from basic syntax to advanced ES6+ features, asynchronous programming, and modern JavaScript patterns. Perfect for beginners and developers looking to strengthen their JavaScript foundation.</p>
                    
                    <h3>Course Topics:</h3>
                    <ul>
                        <li><strong>JavaScript Basics:</strong> Variables, data types, operators, control structures (if/else, loops), functions, and scope.</li>
                        <li><strong>ES6+ Modern JavaScript:</strong> Arrow functions, template literals, destructuring, spread/rest operators, default parameters, and enhanced object literals.</li>
                        <li><strong>Arrays & Objects:</strong> Master array methods (map, filter, reduce), object manipulation, JSON, and working with complex data structures.</li>
                        <li><strong>Asynchronous JavaScript:</strong> Understand callbacks, promises, async/await, fetch API, and handle asynchronous operations effectively.</li>
                        <li><strong>DOM Manipulation:</strong> Select and manipulate DOM elements, handle events, create dynamic content, and build interactive web pages.</li>
                        <li><strong>Advanced Concepts:</strong> Closures, this binding, prototypes, classes, modules (ES6 modules), error handling, and debugging techniques.</li>
                        <li><strong>Best Practices:</strong> Code organization, naming conventions, code quality, and writing maintainable JavaScript code.</li>
                    </ul>
                    
                    <h3>Hands-On Practice:</h3>
                    <p>Build interactive web applications including a todo app, a weather dashboard, a calculator, and a quiz application that demonstrates your JavaScript skills.</p>
                    
                    <h3>Why JavaScript?</h3>
                    <p>JavaScript is essential for web development, mobile app development (React Native), backend development (Node.js), and even desktop applications. Master JavaScript and unlock endless possibilities.</p>
                `
            }
        ],
        teachers: [
            {
                id: 2,
                image: 'teacher-2.svg',
                translations: [{ name: 'Sarah Johnson' }]
            }
        ],
        programs: [
            {
                id: 1,
                slug: 'web-development',
                image: 'program-1.svg',
                translations: [
                    {
                        name: 'Web Development Program',
                        description: `
                            <h2>Complete Web Development Program</h2>
                            <p>Our comprehensive Web Development Program is designed to transform you from a beginner to a professional full-stack developer. This intensive program covers all aspects of modern web development, from creating beautiful user interfaces to building robust server-side applications. With over 400 hours of hands-on training, you'll master the technologies and skills needed to build production-ready web applications.</p>
                            
                            <h3>What You'll Learn:</h3>
                            <ul>
                                <li><strong>Frontend Development:</strong> Master HTML5, CSS3, JavaScript (ES6+), and modern frameworks like React. Learn to create responsive, interactive user interfaces that work seamlessly across all devices.</li>
                                <li><strong>Backend Development:</strong> Build powerful server-side applications using Node.js and Express. Learn RESTful API design, authentication, and database integration.</li>
                                <li><strong>Full-Stack Integration:</strong> Connect frontend and backend systems, implement real-time features, and deploy applications to production environments.</li>
                                <li><strong>Best Practices:</strong> Follow industry standards for code organization, version control with Git, testing, and performance optimization.</li>
                                <li><strong>DevOps & Deployment:</strong> Deploy applications using cloud platforms, configure CI/CD pipelines, and manage production environments.</li>
                            </ul>
                            
                            <h3>Career Opportunities:</h3>
                            <p>Upon completion, you'll be prepared for roles such as Frontend Developer, Backend Developer, Full-Stack Developer, or Web Application Developer in top tech companies worldwide.</p>
                            
                            <h3>Program Features:</h3>
                            <ul>
                                <li>Hands-on projects and real-world case studies</li>
                                <li>Expert instructors with industry experience</li>
                                <li>Career support and job placement assistance</li>
                                <li>Lifetime access to course materials and updates</li>
                                <li>Portfolio development and code reviews</li>
                            </ul>
                        `
                    },
                    {
                        name: 'برنامج تطوير الويب الكامل',
                        description: `
                            <h2>برنامج تطوير الويب الكامل</h2>
                            <p>تم تصميم برنامج تطوير الويب الشامل لدينا لتحويلك من مبتدئ إلى مطور كامل المكدس محترف. يغطي هذا البرنامج المكثف جميع جوانب تطوير الويب الحديث، من إنشاء واجهات مستخدم جميلة إلى بناء تطبيقات قوية من جانب الخادم. مع أكثر من 400 ساعة من التدريب العملي، سوف تتقن التقنيات والمهارات اللازمة لبناء تطبيقات ويب جاهزة للإنتاج.</p>
                            
                            <h3>ما سوف تتعلمه:</h3>
                            <ul>
                                <li><strong>تطوير الواجهة الأمامية:</strong> إتقان HTML5 و CSS3 و JavaScript (ES6+) وأطر العمل الحديثة مثل React. تعلم إنشاء واجهات مستخدم تفاعلية ومتجاوبة تعمل بسلاسة عبر جميع الأجهزة.</li>
                                <li><strong>تطوير الواجهة الخلفية:</strong> بناء تطبيقات قوية من جانب الخادم باستخدام Node.js و Express. تعلم تصميم واجهات برمجة تطبيقات RESTful والمصادقة وتكامل قواعد البيانات.</li>
                                <li><strong>تكامل المكدس الكامل:</strong> ربط أنظمة الواجهة الأمامية والخلفية، تنفيذ ميزات الوقت الفعلي، ونشر التطبيقات في بيئات الإنتاج.</li>
                                <li><strong>أفضل الممارسات:</strong> اتبع معايير الصناعة لتنظيم الكود والتحكم في الإصدار باستخدام Git والاختبار وتحسين الأداء.</li>
                                <li><strong>DevOps والنشر:</strong> نشر التطبيقات باستخدام منصات السحابة، تكوين خطوط أنابيب CI/CD، وإدارة بيئات الإنتاج.</li>
                            </ul>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>عند الانتهاء، ستكون مستعدًا لأدوار مثل مطور الواجهة الأمامية، مطور الواجهة الخلفية، مطور المكدس الكامل، أو مطور تطبيقات الويب في أفضل شركات التكنولوجيا في جميع أنحاء العالم.</p>
                            
                            <h3>مميزات البرنامج:</h3>
                            <ul>
                                <li>مشاريع عملية ودراسات حالة من العالم الحقيقي</li>
                                <li>مدربون خبراء مع خبرة في الصناعة</li>
                                <li>دعم الوظائف ومساعدة في التوظيف</li>
                                <li>وصول مدى الحياة إلى المواد التعليمية والتحديثات</li>
                                <li>تطوير المحفظة ومراجعات الكود</li>
                            </ul>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 9,
        slug: 'machine-learning-basics',
        image: 'course-9.svg',
        hours: 55,
        price: 3200,
        createdAt: '2024-04-01',
        translations: [
            {
                name: 'Machine Learning Basics',
                description: `
                    <h2>Machine Learning Basics & Applications</h2>
                    <p>Introduction to the fascinating world of machine learning. Learn the fundamental concepts, algorithms, and practical applications of machine learning using Python and popular libraries. No prior ML experience required - we'll start from the basics and build your understanding step by step.</p>
                    
                    <h3>What You'll Learn:</h3>
                    <ul>
                        <li><strong>ML Fundamentals:</strong> Understand supervised vs unsupervised learning, training vs testing data, overfitting, bias-variance tradeoff, and model evaluation metrics.</li>
                        <li><strong>Supervised Learning:</strong> Implement linear regression, logistic regression, decision trees, random forests, and support vector machines using scikit-learn.</li>
                        <li><strong>Unsupervised Learning:</strong> Master clustering algorithms (K-means, hierarchical clustering), dimensionality reduction (PCA), and anomaly detection.</li>
                        <li><strong>Neural Networks Introduction:</strong> Get introduced to artificial neural networks, understand how they work, and build simple neural networks using TensorFlow/Keras.</li>
                        <li><strong>Feature Engineering:</strong> Learn to select, transform, and create features that improve model performance. Handle categorical variables and text data.</li>
                        <li><strong>Model Evaluation:</strong> Use cross-validation, confusion matrices, ROC curves, and other metrics to evaluate and compare models.</li>
                        <li><strong>Practical Applications:</strong> Build projects including email spam detection, image classification, customer segmentation, and price prediction models.</li>
                    </ul>
                    
                    <h3>Real-World Projects:</h3>
                    <p>Work on industry-relevant projects including predicting house prices, classifying images, detecting fraud, and building recommendation systems.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>Basic Python programming knowledge and familiarity with NumPy and Pandas is recommended. Basic statistics knowledge is helpful.</p>
                `
            }
        ],
        teachers: [
            {
                id: 4,
                image: 'teacher-4.svg',
                translations: [{ name: 'Emily Davis' }]
            }
        ],
        programs: [
            {
                id: 2,
                slug: 'data-science',
                image: 'program-2.svg',
                translations: [
                    {
                        name: 'Data Science Program',
                        description: `
                            <h2>Comprehensive Data Science Program</h2>
                            <p>Embark on a journey into the world of data science with our comprehensive program that covers everything from statistical analysis to advanced machine learning and artificial intelligence. Whether you're a complete beginner or looking to advance your skills, this program provides the foundation and advanced techniques needed to excel in the rapidly growing field of data science.</p>
                            
                            <h3>Curriculum Overview:</h3>
                            <ul>
                                <li><strong>Statistics & Probability:</strong> Master fundamental statistical concepts, hypothesis testing, regression analysis, and probability distributions essential for data analysis.</li>
                                <li><strong>Python Programming:</strong> Learn Python from scratch with focus on data manipulation using NumPy, Pandas, and data visualization with Matplotlib and Seaborn.</li>
                                <li><strong>Data Wrangling:</strong> Clean, transform, and prepare messy real-world data for analysis. Learn to handle missing data, outliers, and data quality issues.</li>
                                <li><strong>Machine Learning:</strong> Implement supervised and unsupervised learning algorithms using scikit-learn. Build predictive models, classification systems, and clustering solutions.</li>
                                <li><strong>Deep Learning:</strong> Introduction to neural networks, TensorFlow, and Keras. Build deep learning models for image recognition, natural language processing, and more.</li>
                                <li><strong>Big Data Technologies:</strong> Work with large datasets using tools like SQL, Apache Spark, and cloud computing platforms.</li>
                            </ul>
                            
                            <h3>Real-World Applications:</h3>
                            <p>Apply your skills to real-world problems including predictive analytics, customer segmentation, fraud detection, recommendation systems, and natural language processing.</p>
                            
                            <h3>Career Path:</h3>
                            <p>Graduates of this program are prepared for roles such as Data Analyst, Data Scientist, Machine Learning Engineer, Business Intelligence Analyst, and AI Specialist.</p>
                        `
                    },
                    {
                        name: 'برنامج علوم البيانات الشامل',
                        description: `
                            <h2>برنامج علوم البيانات الشامل</h2>
                            <p>انطلق في رحلة إلى عالم علوم البيانات مع برنامجنا الشامل الذي يغطي كل شيء من التحليل الإحصائي إلى التعلم الآلي المتقدم والذكاء الاصطناعي. سواء كنت مبتدئًا تمامًا أو تتطلع إلى تطوير مهاراتك، يوفر هذا البرنامج الأساس والتقنيات المتقدمة اللازمة للتفوق في مجال علوم البيانات سريع النمو.</p>
                            
                            <h3>نظرة عامة على المنهج:</h3>
                            <ul>
                                <li><strong>الإحصاء والاحتمالات:</strong> إتقان المفاهيم الإحصائية الأساسية، اختبار الفرضيات، تحليل الانحدار، وتوزيعات الاحتمالات الضرورية لتحليل البيانات.</li>
                                <li><strong>برمجة Python:</strong> تعلم Python من الصفر مع التركيز على معالجة البيانات باستخدام NumPy و Pandas وتصور البيانات باستخدام Matplotlib و Seaborn.</li>
                                <li><strong>معالجة البيانات:</strong> تنظيف وتحويل وإعداد البيانات الفعلية الفوضوية للتحليل. تعلم التعامل مع البيانات المفقودة والقيم المتطرفة ومشاكل جودة البيانات.</li>
                                <li><strong>التعلم الآلي:</strong> تنفيذ خوارزميات التعلم الخاضع للإشراف وغير الخاضع للإشراف باستخدام scikit-learn. بناء نماذج تنبؤية وأنظمة تصنيف وحلول التجميع.</li>
                                <li><strong>التعلم العميق:</strong> مقدمة للشبكات العصبية و TensorFlow و Keras. بناء نماذج التعلم العميق للتعرف على الصور ومعالجة اللغة الطبيعية والمزيد.</li>
                                <li><strong>تقنيات البيانات الضخمة:</strong> العمل مع مجموعات البيانات الكبيرة باستخدام أدوات مثل SQL و Apache Spark ومنصات الحوسبة السحابية.</li>
                            </ul>
                            
                            <h3>التطبيقات الواقعية:</h3>
                            <p>طبق مهاراتك على مشاكل واقعية بما في ذلك التحليلات التنبؤية وتقسيم العملاء وكشف الاحتيال وأنظمة التوصية ومعالجة اللغة الطبيعية.</p>
                            
                            <h3>المسار الوظيفي:</h3>
                            <p>خريجو هذا البرنامج مستعدون لأدوار مثل محلل البيانات وعالم البيانات ومهندس التعلم الآلي ومحلل ذكاء الأعمال وأخصائي الذكاء الاصطناعي.</p>
                        `
                    }
                ]
            }
        ]
    },
    {
        id: 10,
        slug: 'full-stack-development',
        image: 'course-10.svg',
        hours: 70,
        price: 4000,
        createdAt: '2024-04-10',
        translations: [
            {
                name: 'Full Stack Development',
                description: `
                    <h2>Complete Full Stack Development Mastery</h2>
                    <p>The ultimate course for becoming a full stack developer. Learn to build complete web applications from frontend to backend, including databases, authentication, APIs, and deployment. This comprehensive course covers the entire development lifecycle from concept to production.</p>
                    
                    <h3>Full Stack Curriculum:</h3>
                    <ul>
                        <li><strong>Frontend Development:</strong> Build modern UIs with React, manage state with Redux, style with CSS-in-JS, and create responsive, accessible interfaces.</li>
                        <li><strong>Backend Development:</strong> Create RESTful APIs with Node.js and Express, implement authentication and authorization, handle file uploads, and work with databases.</li>
                        <li><strong>Database Integration:</strong> Design database schemas, write SQL queries, integrate MongoDB and PostgreSQL, and optimize database performance.</li>
                        <li><strong>API Integration:</strong> Connect frontend to backend APIs, handle authentication tokens, manage API errors, and implement real-time features with WebSockets.</li>
                        <li><strong>Authentication & Security:</strong> Implement JWT authentication, password hashing, OAuth integration, CORS, and security best practices.</li>
                        <li><strong>Testing:</strong> Write unit tests, integration tests, and end-to-end tests for both frontend and backend. Use Jest, React Testing Library, and Supertest.</li>
                        <li><strong>DevOps & Deployment:</strong> Deploy applications to cloud platforms (AWS, Heroku, Vercel), set up CI/CD pipelines, configure domains, and monitor production applications.</li>
                        <li><strong>Best Practices:</strong> Follow industry standards for code organization, Git workflow, code reviews, documentation, and team collaboration.</li>
                    </ul>
                    
                    <h3>Capstone Project:</h3>
                    <p>Build a complete full stack application from scratch - an e-commerce platform or social media application with user authentication, real-time features, payment integration, and admin dashboard.</p>
                    
                    <h3>Career Preparation:</h3>
                    <p>This course prepares you for full stack developer roles. You'll have a portfolio of complete applications demonstrating your ability to build and deploy production-ready web applications.</p>
                    
                    <h3>Prerequisites:</h3>
                    <p>Solid understanding of JavaScript, basic knowledge of HTML/CSS, and familiarity with command line. Prior experience with React and Node.js is helpful but not required.</p>
                `
            }
        ],
        teachers: [
            {
                id: 1,
                image: 'teacher-1.svg',
                translations: [{ name: 'John Smith' }]
            },
            {
                id: 3,
                image: 'teacher-3.svg',
                translations: [{ name: 'Michael Brown' }]
            }
        ],
        programs: [
            {
                id: 1,
                slug: 'web-development',
                image: 'program-1.svg',
                translations: [
                    {
                        name: 'Web Development Program',
                        description: `
                            <h2>Complete Web Development Program</h2>
                            <p>Our comprehensive Web Development Program is designed to transform you from a beginner to a professional full-stack developer. This intensive program covers all aspects of modern web development, from creating beautiful user interfaces to building robust server-side applications. With over 400 hours of hands-on training, you'll master the technologies and skills needed to build production-ready web applications.</p>
                            
                            <h3>What You'll Learn:</h3>
                            <ul>
                                <li><strong>Frontend Development:</strong> Master HTML5, CSS3, JavaScript (ES6+), and modern frameworks like React. Learn to create responsive, interactive user interfaces that work seamlessly across all devices.</li>
                                <li><strong>Backend Development:</strong> Build powerful server-side applications using Node.js and Express. Learn RESTful API design, authentication, and database integration.</li>
                                <li><strong>Full-Stack Integration:</strong> Connect frontend and backend systems, implement real-time features, and deploy applications to production environments.</li>
                                <li><strong>Best Practices:</strong> Follow industry standards for code organization, version control with Git, testing, and performance optimization.</li>
                                <li><strong>DevOps & Deployment:</strong> Deploy applications using cloud platforms, configure CI/CD pipelines, and manage production environments.</li>
                            </ul>
                            
                            <h3>Career Opportunities:</h3>
                            <p>Upon completion, you'll be prepared for roles such as Frontend Developer, Backend Developer, Full-Stack Developer, or Web Application Developer in top tech companies worldwide.</p>
                            
                            <h3>Program Features:</h3>
                            <ul>
                                <li>Hands-on projects and real-world case studies</li>
                                <li>Expert instructors with industry experience</li>
                                <li>Career support and job placement assistance</li>
                                <li>Lifetime access to course materials and updates</li>
                                <li>Portfolio development and code reviews</li>
                            </ul>
                        `
                    },
                    {
                        name: 'برنامج تطوير الويب الكامل',
                        description: `
                            <h2>برنامج تطوير الويب الكامل</h2>
                            <p>تم تصميم برنامج تطوير الويب الشامل لدينا لتحويلك من مبتدئ إلى مطور كامل المكدس محترف. يغطي هذا البرنامج المكثف جميع جوانب تطوير الويب الحديث، من إنشاء واجهات مستخدم جميلة إلى بناء تطبيقات قوية من جانب الخادم. مع أكثر من 400 ساعة من التدريب العملي، سوف تتقن التقنيات والمهارات اللازمة لبناء تطبيقات ويب جاهزة للإنتاج.</p>
                            
                            <h3>ما سوف تتعلمه:</h3>
                            <ul>
                                <li><strong>تطوير الواجهة الأمامية:</strong> إتقان HTML5 و CSS3 و JavaScript (ES6+) وأطر العمل الحديثة مثل React. تعلم إنشاء واجهات مستخدم تفاعلية ومتجاوبة تعمل بسلاسة عبر جميع الأجهزة.</li>
                                <li><strong>تطوير الواجهة الخلفية:</strong> بناء تطبيقات قوية من جانب الخادم باستخدام Node.js و Express. تعلم تصميم واجهات برمجة تطبيقات RESTful والمصادقة وتكامل قواعد البيانات.</li>
                                <li><strong>تكامل المكدس الكامل:</strong> ربط أنظمة الواجهة الأمامية والخلفية، تنفيذ ميزات الوقت الفعلي، ونشر التطبيقات في بيئات الإنتاج.</li>
                                <li><strong>أفضل الممارسات:</strong> اتبع معايير الصناعة لتنظيم الكود والتحكم في الإصدار باستخدام Git والاختبار وتحسين الأداء.</li>
                                <li><strong>DevOps والنشر:</strong> نشر التطبيقات باستخدام منصات السحابة، تكوين خطوط أنابيب CI/CD، وإدارة بيئات الإنتاج.</li>
                            </ul>
                            
                            <h3>الفرص الوظيفية:</h3>
                            <p>عند الانتهاء، ستكون مستعدًا لأدوار مثل مطور الواجهة الأمامية، مطور الواجهة الخلفية، مطور المكدس الكامل، أو مطور تطبيقات الويب في أفضل شركات التكنولوجيا في جميع أنحاء العالم.</p>
                            
                            <h3>مميزات البرنامج:</h3>
                            <ul>
                                <li>مشاريع عملية ودراسات حالة من العالم الحقيقي</li>
                                <li>مدربون خبراء مع خبرة في الصناعة</li>
                                <li>دعم الوظائف ومساعدة في التوظيف</li>
                                <li>وصول مدى الحياة إلى المواد التعليمية والتحديثات</li>
                                <li>تطوير المحفظة ومراجعات الكود</li>
                            </ul>
                        `
                    }
                ]
            }
        ]
    }
];

// Helper function to get translation based on locale
const getTranslation = (item, locale) => {
    if (!item || !item.translations || item.translations.length === 0) {
        return item;
    }
    
    // locale 'ar' uses index 1 (Arabic), 'en' uses index 0 (English)
    const translationIndex = locale === 'ar' ? 1 : 0;
    
    // If translation doesn't exist for the locale, fallback to index 0
    const translation = item.translations[translationIndex] || item.translations[0];
    
    return {
        ...item,
        translations: [translation]
    };
};

class Course {
    getCourses = (slug, page, locale) => {
        return new Promise((resolve) => {
            // Simulate API delay
            setTimeout(() => {
                // Filter courses by program slug
                let filteredCourses = DEMO_COURSES;
                if (slug) {
                    filteredCourses = DEMO_COURSES.filter(course =>
                        course.programs.some(program => program.slug === slug)
                    );
                }

                // Apply locale-based translations
                const localizedCourses = filteredCourses.map(course => {
                    const localizedCourse = getTranslation(course, locale);
                    
                    // Also localize nested programs and teachers
                    if (localizedCourse.programs) {
                        localizedCourse.programs = localizedCourse.programs.map(program => 
                            getTranslation(program, locale)
                        );
                    }
                    
                    if (localizedCourse.teachers) {
                        localizedCourse.teachers = localizedCourse.teachers.map(teacher => 
                            getTranslation(teacher, locale)
                        );
                    }
                    
                    return localizedCourse;
                });

                // Pagination
                const pageSize = 10;
                const startIndex = (page - 1) * pageSize;
                const endIndex = startIndex + pageSize;
                const paginatedCourses = localizedCourses.slice(startIndex, endIndex);

                resolve({
                    data: {
                        data: paginatedCourses,
                        meta: {
                            totalItems: localizedCourses.length,
                            itemCount: paginatedCourses.length,
                            itemsPerPage: pageSize,
                            totalPages: Math.ceil(localizedCourses.length / pageSize),
                            currentPage: page
                        }
                    }
                });
            }, 300);
        });
    }

    getCourseBySlug = (slug, locale) => {
        return new Promise((resolve) => {
            // Simulate API delay
            setTimeout(() => {
                const course = DEMO_COURSES.find(c => c.slug === slug);
                if (course) {
                    // Apply locale-based translations
                    const localizedCourse = getTranslation(course, locale);
                    
                    // Also localize nested programs and teachers
                    if (localizedCourse.programs) {
                        localizedCourse.programs = localizedCourse.programs.map(program => 
                            getTranslation(program, locale)
                        );
                    }
                    
                    if (localizedCourse.teachers) {
                        localizedCourse.teachers = localizedCourse.teachers.map(teacher => 
                            getTranslation(teacher, locale)
                        );
                    }
                    
                    resolve({
                        data: {
                            data: localizedCourse
                        }
                    });
                } else {
                    resolve({
                        data: {
                            data: null
                        }
                    });
                }
            }, 300);
        });
    }
}

export const COURSE = new Course();
